(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name EspaiController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('EspaiController', EspaiController);

    EspaiController.$inject = ["$timeout","debugService"];

    function EspaiController($timeout,debugService)
    {
    	var vm = this;
    	
    }
    
})();